<div class="ds-dashboard" [ngClass]="{'dashboardData_show': showDashboard, 'dashboardData_hide': !showDashboard}">

  <!-- Skeleton Loader -->
  @if (!dashboardDataLoaded) {
    <div class="ds-welcome-section">
      <div class="skeleton skeleton-title" style="width: 280px; height: 32px;"></div>
      <div class="skeleton" style="width: 360px; height: 18px; margin-top: 8px;"></div>
    </div>
    <div class="ds-quick-actions">
      @for (i of [1,2,3,4,5,6]; track i) {
        <div class="skeleton" style="height: 96px; border-radius: 12px;"></div>
      }
    </div>
    <div class="ds-stats-row">
      @for (i of [1,2,3,4]; track i) {
        <div class="skeleton skeleton-stat-card"></div>
      }
    </div>
    <div class="skeleton" style="height: 280px; border-radius: 16px; margin-top: 1.5rem;"></div>
  }

  <!-- Dashboard Content -->
  @if (dashboardDataLoaded) {
    <!-- Welcome -->
    <div class="ds-welcome-section">
      <h1 class="ds-welcome-title">{{ 'dsArtistDashboard.welcomeBack' | transloco: { firstName: firstName } }}</h1>
      <p class="ds-welcome-subtitle">{{ 'dsArtistDashboard.whatToday' | transloco }}</p>
    </div>

    <!-- LAUNCHER — the things an artist actually comes here to do, front and centre.
         Each card: illustrative icon (assets/images/artist-quick-start) + stacked title + chevron. -->
    <div class="ds-section ds-launcher">
      <div class="ds-quick-actions">
        <!-- Add an artwork -->
        <div class="ds-action-card" (click)="navigateToCreateArtwork()">
          <img class="ds-action-img" src="assets/images/artist-quick-start/add-art.jpg" alt="" aria-hidden="true" />
          <span class="ds-action-title">{{ 'dsArtistDashboard.addArtwork' | transloco }}</span>
          <img class="ds-action-chevron" src="assets/images/artist-quick-start/arrow.png" alt="" aria-hidden="true" />
        </div>
        <!-- Enhance artwork photos -->
        <div class="ds-action-card" (click)="navigateToArtworks()">
          <img class="ds-action-img" src="assets/images/artist-quick-start/fix-images.jpg" alt="" aria-hidden="true" />
          <span class="ds-action-title">{{ 'dsArtistDashboard.fixImage' | transloco }}</span>
          <img class="ds-action-chevron" src="assets/images/artist-quick-start/arrow.png" alt="" aria-hidden="true" />
        </div>
        <!-- Update your website -->
        <div class="ds-action-card" (click)="navigateToPortfolio()">
          <img class="ds-action-img" src="assets/images/artist-quick-start/web.jpg" alt="" aria-hidden="true" />
          <span class="ds-action-title">{{ 'dsArtistDashboard.updateWebsite' | transloco }}</span>
          <img class="ds-action-chevron" src="assets/images/artist-quick-start/arrow.png" alt="" aria-hidden="true" />
        </div>
        <!-- Enter an event -->
        <div class="ds-action-card" (click)="navigateToEvents()">
          <img class="ds-action-img" src="assets/images/artist-quick-start/add-event.jpg" alt="" aria-hidden="true" />
          <span class="ds-action-title">{{ 'dsArtistDashboard.enterEvents' | transloco }}</span>
          <img class="ds-action-chevron" src="assets/images/artist-quick-start/arrow.png" alt="" aria-hidden="true" />
        </div>
        <!-- Connect with galleries -->
        <div class="ds-action-card" (click)="navigateToConnectedGalleries()">
          <img class="ds-action-img" src="assets/images/artist-quick-start/gallery.jpg" alt="" aria-hidden="true" />
          <span class="ds-action-title">{{ 'dsArtistDashboard.connectGalleries' | transloco }}</span>
          <img class="ds-action-chevron" src="assets/images/artist-quick-start/arrow.png" alt="" aria-hidden="true" />
        </div>
        <!-- Create some marketing -->
        <div class="ds-action-card" (click)="navigateToMarketing()">
          <img class="ds-action-img" src="assets/images/artist-quick-start/marketing.jpg" alt="" aria-hidden="true" />
          <span class="ds-action-title">{{ 'dsArtistDashboard.doMarketing' | transloco }}</span>
          <img class="ds-action-chevron" src="assets/images/artist-quick-start/arrow.png" alt="" aria-hidden="true" />
        </div>
      </div>
    </div>

    <!-- SECONDARY — your numbers, recent work and website. Below the fold by design. -->
    <div class="ds-secondary">
      <!-- Stats Overview -->
      <div class="ds-stats-header">
        <h2 class="ds-stats-title">{{ 'dsArtistDashboard.performanceOverview' | transloco }}</h2>
        <p class="ds-stats-subtitle">{{ 'dsArtistDashboard.performanceSubtitle' | transloco }}</p>
      </div>
      <div class="ds-stats-row">
        <div class="ds-stat-card">
          <div class="ds-stat-icon ds-icon-teal">
            <i class="fa fa-picture-o"></i>
          </div>
          <div class="ds-stat-content">
            <div class="ds-stat-value">{{ dashboardData.NewProductsAdded?.length || 0 }}</div>
            <div class="ds-stat-label">{{ 'dsArtistDashboard.totalArtworks' | transloco }}</div>
          </div>
        </div>
        <div class="ds-stat-card">
          <div class="ds-stat-icon ds-icon-orange">
            <i class="fa fa-building"></i>
          </div>
          <div class="ds-stat-content">
            <div class="ds-stat-value">{{ dashboardData.Galleries?.length || 0 }}</div>
            <div class="ds-stat-label">{{ 'dsArtistDashboard.galleryConnections' | transloco }}</div>
          </div>
        </div>
        <div class="ds-stat-card">
          <div class="ds-stat-icon ds-icon-teal">
            <i class="fa fa-eye"></i>
          </div>
          <div class="ds-stat-content">
            <div class="ds-stat-value">{{ dashboardData.TotalConsignmentsThisYear || 0 }}</div>
            <div class="ds-stat-label">{{ 'dsArtistDashboard.portfolioViews' | transloco }}</div>
            <div class="ds-stat-change">{{ 'dsArtistDashboard.up15ThisMonth' | transloco }}</div>
          </div>
        </div>
        <div class="ds-stat-card">
          <div class="ds-stat-icon ds-icon-orange">
            <i class="fa fa-usd"></i>
          </div>
          <div class="ds-stat-content">
            <div class="ds-stat-value">{{ dashboardData.RevenueThisMonth | currency:'USD':'symbol':'1.0-0' }}</div>
            <div class="ds-stat-label">{{ 'dsArtistDashboard.thisMonthRevenue' | transloco }}</div>
            <div class="ds-stat-change">{{ 'dsArtistDashboard.up8ThisMonth' | transloco }}</div>
          </div>
        </div>
      </div>

      <!-- Recent Activity Section -->
      <div class="ds-section">
        <div class="ds-section-header">
          <i class="fa fa-clock ds-section-icon"></i>
          <div>
            <h2 class="ds-section-title">{{ 'dsArtistDashboard.recentActivity' | transloco }}</h2>
            <p class="ds-section-subtitle">{{ 'dsArtistDashboard.recentActivitySubtitle' | transloco }}</p>
          </div>
        </div>
        <div class="ds-activity-content">
          @if (!dashboardData.NewProductsAdded || dashboardData.NewProductsAdded.length === 0) {
            <div class="ds-empty-artwork">
              <i class="fa fa-picture-o"></i>
              <h4>{{ 'dsArtistDashboard.noArtworksYet' | transloco }}</h4>
              <p>{{ 'dsArtistDashboard.noArtworksYetText' | transloco }}</p>
              <button pButton type="button" [label]="'dsArtistDashboard.addYourFirstArtwork' | transloco" icon="fa fa-plus"
              class="p-button-outlined" (click)="navigateToCreateArtwork()"></button>
            </div>
          } @else {
            <!-- Recent artworks via the shared design-system card (square + object-fit:contain,
                 never cropped — see start-here.md / .conventions.md image-display rule). -->
            <ds-artwork-grid context="artist-recent-products" #arp class="d-block">
              @for (product of dashboardData.NewProductsAdded?.slice(0, 6); track product) {
                <ds-artwork-card
                  [size]="arp.size"
                  [imageUrl]="product.ResizedImageUrl"
                  [name]="product.ProductName"
                  [subtitle]="product.Category"
                  [price]="product.ArtistRevenue"
                  (cardClick)="goToProductDetails(product)"></ds-artwork-card>
              }
            </ds-artwork-grid>
            <div class="ds-view-all">
              <a (click)="navigateToArtworks()">{{ 'dsArtistDashboard.viewAllArtworks' | transloco }} <i class="fa fa-arrow-right"></i></a>
            </div>
          }
        </div>
      </div>

      <!-- Your Portfolio Website Section -->
      <div class="ds-section">
        <div class="ds-section-header">
          <i class="fa fa-globe ds-section-icon"></i>
          <div>
            <h2 class="ds-section-title">{{ 'dsArtistDashboard.portfolioWebsite' | transloco }}</h2>
            <p class="ds-section-subtitle">{{ 'dsArtistDashboard.portfolioWebsiteSubtitle' | transloco }}</p>
          </div>
        </div>
        <div class="ds-portfolio-content">
          <div class="ds-portfolio-card">
            <div class="ds-portfolio-icon">
              <i class="fa fa-globe"></i>
            </div>
            <div class="ds-portfolio-info">
              <div class="ds-portfolio-status">{{ 'dsArtistDashboard.portfolioPublished' | transloco }}</div>
              <a class="ds-portfolio-url" [href]="'https://portal.artflow-pro.com/profile/' + artistId" target="_blank">
                portal.artflow-pro.com/profile/{{ firstName | lowercase }}
              </a>
              <div class="ds-portfolio-stats">
                <span><i class="fa fa-eye"></i> {{ 'dsArtistDashboard.viewsThisMonth' | transloco: { count: (dashboardData.TotalConsignmentsThisYear || 0) } }}</span>
                <span><i class="fa fa-folder"></i> {{ 'dsArtistDashboard.portfoliosPublished' | transloco: { count: (dashboardData.NewProductsAdded?.length || 0) } }}</span>
              </div>
            </div>
            <div class="ds-portfolio-actions">
              <button pButton type="button" [label]="'dsArtistDashboard.share' | transloco" icon="fa fa-share-alt"
              class="p-button-outlined" (click)="sharePortfolio()"></button>
              <button pButton type="button" [label]="'dsArtistDashboard.viewSite' | transloco" icon="fa fa-external-link-alt"
              class="p-button-outlined" (click)="viewPortfolio()"></button>
            </div>
          </div>
        </div>
      </div>

      <!-- Coaching cards — kept in the markup but hidden via CSS (.ds-coaching) for now -->
      <div class="ds-coaching">
        <div class="ds-tip-banner">
          <i class="fa fa-lightbulb-o"></i>
          <span><strong>{{ 'dsArtistDashboard.proTip' | transloco }}</strong> {{ 'dsArtistDashboard.proTipText' | transloco }}</span>
        </div>
        <div class="ds-tips-row">
          <div class="ds-tip-card">
            <div class="ds-tip-icon ds-tip-icon-teal">
              <i class="fa fa-camera"></i>
            </div>
            <div class="ds-tip-content">
              <span class="ds-tip-title">{{ 'dsArtistDashboard.highQualityImagesTitle' | transloco }}</span>
              <span class="ds-tip-text">{{ 'dsArtistDashboard.highQualityImagesText' | transloco }}</span>
            </div>
          </div>
          <div class="ds-tip-card">
            <div class="ds-tip-icon ds-tip-icon-orange">
              <i class="fa fa-tags"></i>
            </div>
            <div class="ds-tip-content">
              <span class="ds-tip-title">{{ 'dsArtistDashboard.accuratePricingTitle' | transloco }}</span>
              <span class="ds-tip-text">{{ 'dsArtistDashboard.accuratePricingText' | transloco }}</span>
            </div>
          </div>
          <div class="ds-tip-card">
            <div class="ds-tip-icon ds-tip-icon-teal">
              <i class="fa fa-pencil"></i>
            </div>
            <div class="ds-tip-content">
              <span class="ds-tip-title">{{ 'dsArtistDashboard.detailedDescriptionsTitle' | transloco }}</span>
              <span class="ds-tip-text">{{ 'dsArtistDashboard.detailedDescriptionsText' | transloco }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
